if (!customElements.get('sticky-button-mobile')) {
	customElements.define(
		'sticky-button-mobile',
		class StickyButtonMobile extends HTMLElement {
			constructor() {
				super();
				this.productFormButtonsClassic = this.querySelector('.product-form__buttons--classic');
			}

			connectedCallback() {
				// Initialiser uniquement le sticky des boutons en mobile
				this.initStickyButtons();
			}

			disconnectedCallback() {
				if (this.observer) {
					this.observer.disconnect();
				}
			}

			initStickyButtons() {
				if (!this.productFormButtonsClassic) return;

				// Trouver le conteneur du formulaire produit
				this.productFormContainer =
					this.querySelector('.product-form__container') ||
					this.productFormButtonsClassic.parentElement;

				if (!this.productFormContainer) return;

				// Créer l'observer pour surveiller le conteneur du formulaire
				this.observer = new IntersectionObserver(
					([entry]) => {
						// Vérifier si on est en mobile
						if (window.innerWidth > 749) {
							this.productFormButtonsClassic.classList.remove('product-form__buttons--fixed');
							return;
						}

						if (entry.isIntersecting) {
							// Le conteneur est visible, boutons normaux
							this.productFormButtonsClassic.classList.remove('product-form__buttons--fixed');
						} else {
							// Le conteneur n'est plus visible, boutons fixes
							this.productFormButtonsClassic.classList.add('product-form__buttons--fixed');
						}
					},
					{
						root: null,
						threshold: 0,
						rootMargin: '0px',
					},
				);

				// Observer le conteneur du formulaire
				this.observer.observe(this.productFormContainer);

				// Gérer le redimensionnement de la fenêtre
				window.addEventListener('resize', () => {
					if (window.innerWidth > 749) {
						this.productFormButtonsClassic.classList.remove('product-form__buttons--fixed');
					}
				});
			}
		},
	);
}
